"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _makeClassNameComponent = require("./makeClassNameComponent");
Object.keys(_makeClassNameComponent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _makeClassNameComponent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _makeClassNameComponent[key];
    }
  });
});